import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { SearchRequest } from '../models/search-request.model';
import { SearchResponse, LoadConfigResponse } from '../models/search-response.model';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  loadConfig(uuidClient: number): Observable<LoadConfigResponse> {
    const url = `${this.baseUrl}/load/${uuidClient}/configuration`;
    return this.http.get<LoadConfigResponse>(url);
  }

  searchAfilliate(payload: SearchRequest): Observable<SearchResponse> {
    const url = `${this.baseUrl}/search/afiliate`;
    return this.http.post<SearchResponse>(url, payload);
  }
}
